import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'

export default function SentryFallback ({ error, componentStack, resetError }) {
  return (
    <div style={styles.container}>
      <Container>
        <Row className="justify-content-center">
          <Col sm={12} md={8}>
            <h1>Ooops...</h1>
            <h2>We may have broken the DAOverse 😮</h2>
            <h5 className='mt-4'>{error.toString()}</h5>
            <details className='mt-2'>{componentStack}</details>
            <Button
              className='mt-4'
              onClick={() => {
                localStorage.clear()
                resetError()
                window.location.reload()
              }}
            >
              Try restoring it?
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

const styles = {
  container: {
    backgroundImage: `url(/imgs/aragon-background.png)`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}
